import Abstract from "../../../../abstract-view/abstract.js";

export default class Pagination extends Abstract {
  constructor(element, parent) {
    super();

    this._element = element;
    this._parent = parent;
  }

  updateElement(element) {
    this._element = element;
  }

  getParentElement() {
    return this._parent;
  }

  getLinksElements() {
    if (!this._element) {
      return [];
    }

    return this._element.querySelectorAll(`a`);
  }

  getLoadButton() {
    if (!this._element) {
      return null;
    }

    return this._element.querySelector(`.button`);
  }
}
